import type { OwnerOption } from '@shared/schemas/admin-access';
import { readStoredJson, tolerantArray } from './readStoredJson';
import { z } from 'zod';

export const IMPERSONATION_RECENT_KEY = 'terra:impersonation:recent';
export const MAX_IMPERSONATION_RECENTS = 5;

export type RecentImpersonationUser = Pick<OwnerOption, 'ownerEmail' | 'slackUserId'>;

const RecentUserSchema = z.looseObject({ ownerEmail: z.string(), slackUserId: z.string() });

export function readRecentUsers(): RecentImpersonationUser[] {
  return readStoredJson(localStorage, IMPERSONATION_RECENT_KEY, tolerantArray(RecentUserSchema), []);
}

export function rememberRecentUser(user: RecentImpersonationUser): void {
  try {
    const recent = readRecentUsers().filter((item) => item.slackUserId !== user.slackUserId);
    recent.unshift({ ownerEmail: user.ownerEmail, slackUserId: user.slackUserId });
    localStorage.setItem(
      IMPERSONATION_RECENT_KEY,
      JSON.stringify(recent.slice(0, MAX_IMPERSONATION_RECENTS)),
    );
  } catch {
    // Recents are best-effort; storage failures must not strand a successful
    // server-side identity switch on the old page.
  }
}
